import * as React from 'react';
import styled from 'styled-components';

import { ReadingText, SubText } from '../Typography';

const Main = styled.div`
  display: grid;
  grid-template-columns: 36px 1fr;
  gap: 8px;
  align-items: center;

  .test-main-text-content {
    display: grid;
    width: 100%;

    .title {
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      max-width: 100%;
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .sub-title {
      font-size: 12px;
      line-height: 16px;
      max-width: 100%;
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .test-main-book-cover {
    height: 36px;
    min-width: 36px;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
`;

interface TestMainInfoProps {
  bookCover: string;
  title: string;
  desc: string;
}

export const TestMainInfo = React.memo((props: TestMainInfoProps) => {
  const { bookCover, title, desc } = props;
  return (
    <Main className="test-main-info">
      <div className="test-main-book-cover">
        <img loading="lazy" src={bookCover} alt="book-cover" />
      </div>
      <div className="test-main-text-content">
        <div className="title">
          <ReadingText text={title} block />
        </div>
        <div className="sub-title">
          <SubText text={desc} />
        </div>
      </div>
    </Main>
  );
});
